import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, map } from 'rxjs/operators'
import { UtilityService } from '../utility/utility.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})


export class LoginService {
  constructor(
    private http: HttpClient,
    private utitlity: UtilityService
  ) { }

  GetCredentials(DomainDetail: any): Observable<any> {
    return this.utitlity.callWithRetry(environment.API_URL_Main + `GetCredentials`, DomainDetail, 0, true, true);
    // return this.http.post<any>(environment.API_URL_Main + `GetCredentials`,
    //   DomainDetail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  Auth(UserDetail: any, ApiUrl: String): Observable<any> {
    return this.utitlity.callWithRetry(ApiUrl + `Auth`, UserDetail, 0, true);
    // return this.http.post<any>(ApiUrl + `Auth`,
    //   UserDetail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  LoginCheck(UserDetail: any, ApiUrl: String): Observable<any> {
    return this.utitlity.callWithRetry(ApiUrl + `LoginCheck/LoginCheck`, UserDetail, 0, true);
    // return this.http.post<any>(ApiUrl + `LoginCheck/LoginCheck`,
    //   UserDetail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  GetCompany(UserDetail: any, ApiUrl: String): Observable<any> {
    return this.utitlity.callWithRetry(ApiUrl + `CompanySelection/GetCompany`, UserDetail, 0, true);
    // return this.http.post<any>(ApiUrl + `CompanySelection/GetCompany`,
    //   UserDetail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  GenerateOTP(OTPDetail: any, ApiUrl: String): Observable<any>  {
    return this.utitlity.callWithRetry(ApiUrl + `Login/GenerateOTP`, OTPDetail, 0, true);
    // return this.http.post<any>(ApiUrl + `Login/GenerateOTP`,
    //   OTPDetail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  SaveForgotPassword(OTPDetail: any, ApiUrl: String): Observable<any>  {
    return this.utitlity.callWithRetry(ApiUrl + `ForgotPassword/Set`, OTPDetail, 0, true);
    // return this.http.post<any>(ApiUrl + `ForgotPassword/Set`,
    //   OTPDetail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  DbNameWithSessionInsret(Detail: any, ApiUrl: String): Observable<any> {
    return this.utitlity.callWithRetry(ApiUrl + `DbNameWithSession/Insret`, Detail, 0, true);
    // return this.http.post<any>(ApiUrl + `DbNameWithSession/Insret`,
    //   Detail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  Ess_Link_ExpiryCheck(Detail: any, ApiUrl: String): Observable<any> {
    return this.utitlity.callWithRetry(ApiUrl + `Ess_Link_Expiry/Check`, Detail, 0, true);
    // return this.http.post<any>(ApiUrl + `Ess_Link_Expiry/Check`,
    //   Detail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }

  ESS_GetLoginDetails(Detail: any, ApiUrl: String): Observable<any> {
    return this.utitlity.callWithRetry(ApiUrl + `ESS_GetLogin/Details`, Detail, 0, true);
    // return this.http.post<any>(ApiUrl + `ESS_GetLogin/Details`,
    //   Detail
    // ).pipe(map(response => {
    //   return response;
    // }));
  }
}